/**
 * SnowMachine Component
 *
 * Seasonal weather machine: snow / fireworks / motes / leaves.
 */

import { useRef, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { getActiveTheme } from '../config/seasonalFeatures';
import SnowMachineDisplay from './SnowMachineDisplay';
import SnowMachineControls from './SnowMachineControls';
import './SnowMachine.css';

const photoPage = "http://photo.myked.com";

export default function SnowMachine() {
  const simulationRef = useRef(null);
  const [controlsReady, setControlsReady] = useState(false);
  const theme = getActiveTheme();

  const handleSimulationReady = () => {
    // Simulation ready; controls wired via SnowSimulation.setupControls()
  };

  const handleControlsReady = () => {
    setControlsReady(true);
  };

  return (
    <Container
      className="p-12"
      style={{ maxWidth: "1800px", paddingTop: "25vh", paddingBottom: "20vh" }}
    >
      <div className="p-3 fluid">
        <div className="text-center align-middle">
          <SnowMachineDisplay 
            simulationRef={simulationRef}
            onSimulationReady={handleSimulationReady}
            controlsReady={controlsReady}
            theme={theme}
          />
          
          <SnowMachineControls 
            simulationRef={simulationRef}
            onControlsReady={handleControlsReady}
            theme={theme}
          />
        </div>
        <br />
        <br />
        <p className="text-center align-middle">
          Hello! My name is Myke D.
          <br /> I am an award-winning <a href={photoPage}>
            content producer
          </a>{" "}
          and <a href="#projects">developer</a> from Minnesota.
          <br />
        </p>
      </div>
    </Container>
  );
}
